export async function swiper() {
    const swiperContainer = document.querySelectorAll('.swiper-container[data-enabled="true"]');

    if (swiperContainer.length) {
        let { initSwiper } = await import(/* webpackMode: "lazy" */ './swiper.async.js');

        initSwiper(swiperContainer);
    }
}
